import { useNavigate, useSearchParams } from "react-router-dom";
import { BookOpen, ArrowLeft, FileText, Clock } from "lucide-react";

export default function ExamSelection() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") || "practice";

  const exams = [
    {
      id: "FE",
      title: "FE Exam",
      subtitle: "Fundamentals of Engineering",
      desc: "First step toward becoming a licensed Professional Engineer",
      color: "from-blue-500 to-blue-600"
    },
    {
      id: "PE",
      title: "PE Exam",
      subtitle: "Principles and Practice of Engineering",
      desc: "Advanced exam for experienced engineers seeking licensure",
      color: "from-green-500 to-green-600"
    }
  ];

  const getModeTitle = () => {
    switch (mode) {
      case "exam": return "Mock Exam";
      case "flashcards": return "Flashcards";
      default: return "Practice Questions";
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-4">
          <button
            data-testid="back-btn"
            onClick={() => navigate("/dashboard")}
            className="btn-ghost p-2"
          >
            <ArrowLeft size={20} />
          </button>
          <div>
            <h1 className="text-xl font-bold text-slate-900">{getModeTitle()}</h1>
            <p className="text-sm text-slate-500">Select your exam type</p>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
        <div className="space-y-4">
          {exams.map((exam) => (
            <button
              key={exam.id}
              data-testid={`exam-${exam.id.toLowerCase()}`}
              onClick={() => navigate(`/disciplines/${exam.id}${mode ? `?mode=${mode}` : ''}`)}
              className="w-full card text-left hover:shadow-lg transition-all group"
            >
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${exam.color} flex items-center justify-center flex-shrink-0`}>
                  <FileText className="w-7 h-7 text-white" />
                </div>
                <div className="flex-1">
                  <h2 className="text-xl font-bold text-slate-900 group-hover:text-blue-600 transition-colors">
                    {exam.title}
                  </h2>
                  <p className="text-slate-600 font-medium">{exam.subtitle}</p>
                  <p className="text-sm text-slate-500 mt-2">{exam.desc}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
